import l from "./initial.js";
function n(n, t, i) {
  return null == n || n.length < 1 ? null == t || i ? void 0 : [] : null == t || i ? n[0] : l(n, n.length - t);
}
export { n as default };